import { render, staticRenderFns } from "./page-main.vue?vue&type=template&id=f915bbc4&scoped=true"
import script from "./page-main.vue?vue&type=script&lang=js"
export * from "./page-main.vue?vue&type=script&lang=js"
import style0 from "./page-main.vue?vue&type=style&index=0&id=f915bbc4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f915bbc4",
  null
  
)

export default component.exports